import { render, staticRenderFns } from "./member_footer_new.vue?vue&type=template&id=17f38d28&scoped=true"
import script from "./member_footer_new.vue?vue&type=script&lang=js"
export * from "./member_footer_new.vue?vue&type=script&lang=js"
import style0 from "./member_footer_new.vue?vue&type=style&index=0&id=17f38d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f38d28",
  null
  
)

export default component.exports